<template>
  <div>
    <div class="login-page">
      <div class="login-panel">
        <div class="login-form" v-show="loginShow">
          <p>账号密码登录</p>
          <el-form :model="loginForm" :rules="loginrules" ref="loginForm">
            <el-form-item prop="webPhone">
              <el-input
                type="text"
                placeholder="请输入您的手机号码"
                autocomplete="off"
                v-model="loginForm.webPhone"
                :validate-event="loginFormPhoneValidate"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                placeholder="输入密码"
                autocomplete="off"
                v-model="loginForm.password"
                :validate-event="loginFormPasswordValidate"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="webValidateCode">
              <div class="verify-content">
                <el-input
                  class="verify-code"
                  placeholder="请输入验证码"
                  v-model="loginForm.webValidateCode"
                  :validate-event="loginFormValidateCodeValidate"
                  clearable
                ></el-input>
                <div>
                  <tr-identify
                    :contentWidth="146"
                    @click="refreshCode"
                    :contentHeight="51"
                    :identifyCode="identifyCode"
                  ></tr-identify>
                  <p @click="refreshCode">点击图片更换验证码</p>
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('loginForm')"
                >登录</el-button
              >
            </el-form-item>
            <el-form-item>
              <div class="bottom-links">
                <span class="orange-font" @click="loginShow = false"
                  >新用户注册 ></span
                >
                <span @click="forgetPassword()">忘记密码？</span>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="register-form" v-show="!loginShow && !forgetShow">
          <p class="new-user-register">新用户注册</p>
          <el-form :model="registForm" :rules="registrules" ref="registForm">
            <el-form-item prop="webPhone">
              <el-input
                type="text"
                placeholder="请输入您的手机号码"
                v-model="registForm.webPhone"
                :validate-event="registFormPhoneValidate"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="webValidateCode">
              <div class="verify-content">
                <el-input
                  :disabled="disableVerifyCode"
                  class="verify-code"
                  placeholder="请输入验证码"
                  type="text"
                  v-model="registForm.webValidateCode"
                  :validate-event="registFormVeryCodeValidate"
                  clearable
                ></el-input>
                <el-button
                  :disabled="disableCanVerfy"
                  type="primary"
                  @click="getapiUserPhoneSms('regist', '300', 'registEntrance')"
                  v-show="showVerifyBtn"
                  >点击获取验证码</el-button
                >
                <el-button type="warning" v-show="!showVerifyBtn" disabled
                  >{{ time }}s</el-button
                >
              </div>
            </el-form-item>
            <el-form-item prop="password2">
              <el-input
                type="password"
                autocomplete="off"
                placeholder="输入密码"
                v-model="registForm.password2"
                :validate-event="registFormPasswordValidate"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="checkPass2" class="reconfirm">
              <el-input
                type="password"
                autocomplete="off"
                placeholder="确认密码"
                v-model="registForm.checkPass2"
                :validate-event="registFormCheckPassValidate"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="checked1">
              <div class="read-protocol">
                <el-checkbox v-model="registForm.checked1">同意</el-checkbox>
                <span
                  class="protocal-link"
                  @click="showProtocal('privacy', '隐私协议')"
                  >《隐私协议》</span
                >
                <span @click="showProtocal('serve', '游记协议')"
                  >《游记协议》</span
                >
              </div>
            </el-form-item>
            <el-form-item>
              <el-button
                class="large-btn"
                type="primary"
                @click="regist('registForm')"
                >注册</el-button
              >
            </el-form-item>
          </el-form>
          <p class="has-account">
            已有账号
            <span @click="loginShow = true">登录</span>
          </p>
        </div>
        <div class="forget-form" v-show="forgetShow">
          <p class="new-user-register">忘记密码设置</p>
          <el-form :model="forgetForm" :rules="forgetRules" ref="forgetForm">
            <el-form-item prop="webPhone">
              <el-input
                type="text"
                placeholder="请输入您的手机号码"
                v-model="forgetForm.webPhone"
                :validate-event="forgetFormPhoneValidate"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="webValidateCode">
              <div class="verify-content">
                <el-input
                  :disabled="disableVerifyCode2"
                  class="verify-code"
                  placeholder="请输入验证码"
                  type="text"
                  v-model="forgetForm.webValidateCode"
                  :validate-event="forgetFormVeryCodeValidate"
                  clearable
                ></el-input>
                <el-button
                  :disabled="disableCanVerfy"
                  type="primary"
                  @click="getapiUserPhoneSms('regist', '300', 'forgetEntrance')"
                  v-show="showVerifyBtn"
                  >点击获取验证码</el-button
                >
                <el-button type="warning" v-show="!showVerifyBtn" disabled
                  >{{ time }}s</el-button
                >
              </div>
            </el-form-item>
            <el-form-item prop="password2">
              <el-input
                type="password"
                autocomplete="off"
                placeholder="输入密码"
                v-model="forgetForm.password2"
                :validate-event="forgetFormPassword2Validate"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="checkPass2" class="reconfirm">
              <el-input
                type="password"
                autocomplete="off"
                placeholder="确认密码"
                v-model="forgetForm.checkPass2"
                :validate-event="forgetFormCheckPass2Validate"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                class="large-btn affirm-edit"
                type="primary"
                @click="updatePassword()"
                >确认修改</el-button
              >
            </el-form-item>
          </el-form>
          <p class="return-login">
            返回
            <span @click="fromForgetToLogin()">登录</span>
          </p>
        </div>
      </div>
      <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.visible"
        width="780px"
      >
        <el-scrollbar style="height:50vh">
          <protocal-privacy
            v-if="dialog.content == 'privacy'"
          ></protocal-privacy>
          <protocal-serve v-if="dialog.content == 'serve'"></protocal-serve>
        </el-scrollbar>
      </el-dialog>
    </div>
    <div class="copyright-white">
      备案号：辽宁ICP备11005457号-6 Copyright © 2016.沈阳美行科技有限公司
      保留所有版权
    </div>
  </div>
</template>
<script>
import {
  login,
  apiUserPhoneSms,
  userRegist,
  checkPhoneUsed,
  checkVerifyCode,
  apiUpdatePasswordByPhone
} from "@/axios/service/user";
import { mapState, mapMutations, mapActions } from "vuex";
import RequestPath from "@/utils/RequestPath";
import api from "@/axios/api";
import Global from "../utils/Global";
import verifyUrl from "@/assets/images/verify.png";
import TrIdentify from "@/components/kits/identify";
import protocalServe from "@/components/protocal/serve";
import protocalPrivacy from "@/components/protocal/privacy";
import SocketIo from "socket.io-client";
export default {
  components: {
    TrIdentify,
    protocalServe,
    protocalPrivacy
  },
  watch: {
    //登录输入验证码后清空校验结果并开启表单项验证
    "loginForm.webValidateCode"(value) {
      this.$refs.loginForm.clearValidate();
      if (value !== "") {
        this.loginFormValidateCodeValidate = true;
      } else {
        this.loginFormValidateCodeValidate = false;
      }
    },
    //登录输入密码后清空校验结果并开启表单项验证
    "loginForm.password"(value) {
      this.$refs.loginForm.clearValidate();
      if (value !== "") {
        this.loginFormPasswordValidate = true;
      } else {
        this.loginFormPasswordValidate = false;
      }
    },
    //登录输入手机号后清空校验结果并开启表单项验证
    "loginForm.webPhone"(value) {
      this.$refs.loginForm.clearValidate();
      if (value !== "") {
        this.loginFormPhoneValidate = true;
      } else {
        this.loginFormPhoneValidate = false;
      }
    },
    //忘记密码再次输入密码后清空校验结果并开启表单项验证
    "forgetForm.checkPass2"(value) {
      this.$refs.forgetForm.clearValidate();
      if (value !== "") {
        this.forgetFormCheckPass2Validate = true;
      } else {
        this.forgetFormCheckPass2Validate = false;
      }
    },
    //忘记密码输入密码后清空校验结果并开启表单项验证
    "forgetForm.password2"(value) {
      this.$refs.forgetForm.clearValidate();
      if (value !== "") {
        this.forgetFormPassword2Validate = true;
      } else {
        this.forgetFormPassword2Validate = false;
      }
    },
    //忘记密码输入验证码后清空校验结果并开启表单项验证
    "forgetForm.webValidateCode"(value) {
      this.$refs.forgetForm.clearValidate();
      if (value !== "") {
        this.forgetFormVeryCodeValidate = true;
      } else {
        this.forgetFormVeryCodeValidate = false;
      }
    },
    //忘记密码输入手机号后清空校验结果并开启表单项验证
    "forgetForm.webPhone"(value) {
      this.$refs.forgetForm.clearValidate();
      if (value !== "") {
        this.forgetFormPhoneValidate = true;
      } else {
        this.forgetFormPhoneValidate = false;
      }
    },
    //注册输入手机号后清空校验结果并开启表单项验证
    "registForm.webPhone"(value) {
      this.$refs.registForm.clearValidate();
      if (value !== "") {
        this.registFormPhoneValidate = true;
      } else {
        this.registFormPhoneValidate = false;
      }
    },
    //注册输入验证码后清空校验结果并开启表单项验证
    "registForm.webValidateCode"(value) {
      this.$refs.registForm.clearValidate();
      if (value !== "") {
        this.registFormVeryCodeValidate = true;
      } else {
        this.registFormVeryCodeValidate = false;
      }
    },
    //注册输入密码后清空校验结果并开启表单项验证
    "registForm.password2"(value) {
      this.$refs.registForm.clearValidate();
      if (value !== "") {
        this.registFormPasswordValidate = true;
      } else {
        this.registFormPasswordValidate = false;
      }
    },
    //注册再次输入密码后清空校验结果并开启表单项验证
    "registForm.checkPass2"(value) {
      this.$refs.registForm.clearValidate();
      if (value !== "") {
        this.registFormCheckPassValidate = true;
      } else {
        this.registFormCheckPassValidate = false;
      }
    },
    //勾选后清空校验结果并开启表单项验证
    "registForm.checked1"(value) {
      this.$refs.registForm.clearValidate();
    },
    loginShow(value) {
      if (value) {
        document.title = "登录_自驾出游好帮手_鹿驾网";
      } else {
        document.title = "注册_自驾出游好帮手_鹿驾网";
      }
    }
  },
  computed: {
    ...mapState("PersonalStore", ["pushMessageAccount"])
  },
  data() {
    //1.注册和2.忘记密码时验证第一个密码
    let validatePass = (rule, value, callback) => {
      //密码需包含字母、数字、符号的组合，空格除外，“空格”除外 (!#$%^&*)
      let numberReg = /[\d]+/;
      let lowerLetter = /[a-z]+/;
      let upperLetter = /[A-Z]+/;
      let spaceLetter = /[\s]+/;
      if (value === "") {
        callback(new Error("密码不能为空，请重新输入"));
      } else {
        if (
          !(
            value.match(numberReg) &&
            (value.match(lowerLetter) || value.match(upperLetter)) &&
            !value.match(spaceLetter)
          )
        ) {
          if (value.length < 8) {
            return callback(new Error("密码需设置8位以上，请重新输入"));
          } else {
            return callback(
              new Error("密码需包含字母、数字、符号的组合，空格除外")
            );
          }
        }
        if (this.registForm.checkPass2 !== "") {
          this.$refs.registForm.validateField("checkPass2");
        }
        callback();
      }
    };
    //注册时验证第二个密码
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.registForm.password2) {
        callback(new Error("两次密码不一致，请核对后重新输入"));
      } else {
        callback();
      }
    };
    //忘记密码时验证第二个密码
    let validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.forgetForm.password2) {
        callback(new Error("两次密码不一致，请核对后重新输入"));
      } else {
        callback();
      }
    };
    let loginValidatePass = (rule, value, callback) => {
      let that = this;
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        if (value !== that.identifyCode) {
          // 增加逻辑：如果验证码输入错误超过三次，则自动刷新验证码
          that.identifyCount++;
          if (that.identifyCount === 4) {
            that.refreshCode();
          }
          callback(new Error("验证码输入有误，请重新输入"));
        }
        callback();
      }
    };
    // 注册时检查验证码
    let checkValidateCode = (rule, value, callback) => {
      let that = this;
      let reg = /^([0-9]{6}$)/;
      if (value === "") {
        callback(new Error("请输入6位数字验证码"));
      } else {
        if (!reg.test(value)) {
          return callback(new Error("请输入6位数字验证码"));
        } else {
          //检查验证码是否正确,是否超时
          checkVerifyCode({
            phone: that.registForm.webPhone,
            validateCode: value,
            oemId: that.apolloConfig.WORK.oemId,
            validSessionId: that.registForm.webValidSessionId
          }).then(json => {
            if (json.respCode === 100) {
              callback();
            } else if (json.respCode === -121) {
              //验证码错误
              callback(new Error("验证码输入错误，请重新输入"));
            } else if (json.respCode === -120) {
              //验证码超时
              callback(new Error("验证码超时，请重新获取"));
            } else {
              callback();
            }
          });
        }
      }
    };
    // 忘记密码时检查验证码
    let checkValidateCodeForget = (rule, value, callback) => {
      let that = this;
      let reg = /^([0-9]{6}$)/;
      if (value === "") {
        callback(new Error("请输入6位数字验证码"));
      } else {
        if (!reg.test(value)) {
          return callback(new Error("请输入6位数字验证码"));
        } else {
          //检查验证码是否正确,是否超时
          checkVerifyCode({
            phone: that.forgetForm.webPhone,
            validateCode: value,
            oemId: that.apolloConfig.WORK.oemId,
            validSessionId: that.forgetForm.webValidSessionId
          }).then(json => {
            if (json.respCode === 100) {
              callback();
            } else if (json.respCode === -121) {
              //验证码错误
              callback(new Error("验证码输入错误，请重新输入"));
            } else if (json.respCode === -120) {
              //验证码超时
              callback(new Error("验证码超时，请重新获取"));
            } else {
              callback();
            }
          });
        }
      }
    };
    //登录时检查手机号
    let loginPhoneValidate = (rule, value, callback) => {
      let that = this;
      let reg = /^(1[3456789][0-9]{9}$)/;
      if (value === "") {
        callback(new Error("请输入11位手机号码"));
      } else {
        if (!reg.test(value)) {
          return callback(new Error("请输入11位手机号码"));
        } else {
          //如果手机号格式校验通过，则调接口判断是否是已经注册的用户
          checkPhoneUsed({
            phone: value,
            oemId: that.apolloConfig.WORK.oemId
          }).then(json => {
            if (json.respCode === 100) {
              //如果是没有注册的手机号，提示
              if (!json.data.isUserExist) {
                return callback(new Error("该手机号码账号不存在"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          });
        }
      }
    };
    //注册时检查手机号
    let valiataRegistPhone = (rule, value, callback) => {
      let that = this;
      let reg = /^(1[3456789][0-9]{9}$)/;
      if (value === "") {
        this.disableCanVerfy = true; //不能点击获取验证码
        callback(new Error("请输入11位手机号码"));
      } else {
        if (!reg.test(value)) {
          this.disableCanVerfy = true; //不能点击获取验证码
          return callback(new Error("请输入11位手机号码"));
        } else {
          //如果是忘记密码则不校验手机号是否注册
          //如果手机号格式校验通过，则调接口判断是否是已经注册的用户
          checkPhoneUsed({
            phone: value,
            oemId: that.apolloConfig.WORK.oemId
          }).then(json => {
            if (json.respCode === 100) {
              //如果是忘记密码页面
              if (this.forgetShow) {
                if (!json.data.isUserExist) {
                  this.disableCanVerfy = true; //手机号未注册不能点击获取验证码按钮
                  return callback(new Error("该手机号未注册，请核对后输入"));
                } else {
                  this.disableCanVerfy = false;
                  callback();
                }
              } else {
                //如果是注册页面
                //如果手机号是已经注册的
                if (json.data.isUserExist) {
                  this.disableCanVerfy = true; //如果当前登录用户又换了一个已经注册的手机号则也不能点击获取验证码
                  return callback(new Error("该手机号已注册，可直接登录"));
                } else {
                  this.disableCanVerfy = false;
                  callback();
                }
              }
            } else {
              this.disableCanVerfy = false;
              callback();
            }
          });
        }
      }
    };
    let checked1Pass = (rule, value, callback) => {
      if (value === false) {
        callback(new Error("未同意《隐私协议》《游记协议》无法注册"));
      }
      callback();
    };
    return {
      loginFormValidateCodeValidate: false, //登录页面输入验证码是否触发表单校验
      loginFormPasswordValidate: false, //登录页面输入密码是否触发表单校验
      loginFormPhoneValidate: false, //登录页面输入电话号是否触发表单校验
      forgetFormCheckPass2Validate: false, //忘记密码再次密码是否触发表单校验
      forgetFormPassword2Validate: false, //忘记密码输入密码是否触发表单校验
      forgetFormVeryCodeValidate: false, //忘记密码输入验证码是否触发表单校验
      forgetFormPhoneValidate: false, //忘记密码输入手机号是否触发表单校验
      registFormCheckPassValidate: false, //注册再次输入密码时是否触发表单的校验
      registFormPasswordValidate: false, //注册输入密码时是否触发表单的校验
      registFormVeryCodeValidate: false, //注册输入验证码时是否触发表单的校验
      registFormPhoneValidate: false, //注册输入手机号时是否触发表单的校验
      disableVerifyCode2: true, //是否可以输入验证码
      disableVerifyCode: true, //是否可以输入验证码
      forgetShow: false, //是否展示忘记密码
      hasGotCode: false, //是否获取过验证码
      disableCanVerfy: true, //是否禁止点击获取验证码
      identifyCount: 0, //验证码验证次数
      identifyCodes: "1234567890",
      // "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
      identifyCode: "",
      verifyUrl: verifyUrl,
      dialog: {
        title: "",
        visible: false,
        content: ""
      },
      loginForm: {
        userName: "",
        webPhone: "",
        password: "",
        webValidSessionId: "",
        webValidateCode: "",
        typeId: "4"
      },
      registForm: {
        checked1: false,
        webPhone: "",
        password2: "",
        checkPass2: "",
        webValidSessionId: "",
        webValidateCode: "",
        typeId: "4"
      },
      forgetForm: {
        webPhone: "",
        webValidSessionId: "",
        webValidateCode: "",
        password2: "",
        checkPass2: "",
        typeId: "4"
      },
      loginShow: true,
      loginrules: {
        /* webPhone: [
          { required: true, message: "请输入11位手机号码", trigger: "blur" },
          { pattern: /^1[34578]\d{9}$/, message: '请输入11位手机号码', trigger: ['blur', 'change'] }
        ], */
        webPhone: [{ validator: loginPhoneValidate, trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码后登录", trigger: "blur" },
          { message: "密码错误", trigger: "blur" }
        ],
        webValidateCode: [{ validator: loginValidatePass, trigger: "blur" }]
      },
      registrules: {
        webPhone: [{ validator: valiataRegistPhone, trigger: "blur" }],
        password2: [{ validator: validatePass, trigger: "blur" }],
        checkPass2: [{ validator: validatePass2, trigger: "blur" }],
        checked1: [{ validator: checked1Pass, trigger: "change" }],
        webValidateCode: [{ validator: checkValidateCode, trigger: "blur" }] //检查注册验证码是否正确
      },
      forgetRules: {
        webPhone: [{ validator: valiataRegistPhone, trigger: "blur" }],
        password2: [{ validator: validatePass, trigger: "blur" }],
        checkPass2: [{ validator: validatePass3, trigger: "blur" }],
        webValidateCode: [
          { validator: checkValidateCodeForget, trigger: "blur" }
        ] //检查忘记密码验证码是否正确
      },
      time: 60,
      showVerifyBtn: true,
      timer: null,
      loginError: {
        "-108": "用户名不存在",
        "-109": "密码错误",
        "-110": "登录应用错误",
        "-136": "管理员账号已失效"
      },
      registError: {
        "-119": "手机号已注册",
        "-120": "验证码超时",
        "-121": "验证码错误"
      },
      webSocket: {}
    };
  },
  created() {
    this.$root.showBottomArea = false;
    if (this.$route.params.type === "login") {
      this.loginShow = true;
      this.forgetShow = false;
    } else if (this.$route.params.type === "register") {
      this.loginShow = false;
      this.forgetShow = false;
    }
    this.$eventHub.$on("pageChange", data => {
      if (data === "login") {
        this.loginShow = true;
        this.forgetShow = false;
      } else if (data === "register") {
        this.loginShow = false;
        this.forgetShow = false;
      }
    });
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4); //生成4位验证码
    // 绑定enter事件
    this.enterKeyup();
  },
  methods: {
    ...mapActions("MessageStore", ["pushMessageAddAction"]),
    changePage(command) {
      // login,register
      if (command === "login") {
        this.loginShow = true;
      }
      this.$router.push({ path: `/minelog/${command}` });
      this.$eventHub.$emit("pageChange", command);
    },
    //确认修改密码
    updatePassword() {
      this.$refs["forgetForm"].validate(valid => {
        if (valid) {
          apiUpdatePasswordByPhone({
            webPhone: this.forgetForm.webPhone,
            webPassword: this.$md5(this.forgetForm.password2),
            webValidSessionId: this.forgetForm.webValidSessionId,
            webValidateCode: this.forgetForm.webValidateCode,
            WebTypeId: this.forgetForm.typeId,
            webOemId: this.apolloConfig.WORK.oemId
          }).then(res => {
            if (res.respCode === 100) {
              this.fromForgetToLogin();
            } else {
              this.$message.error("修改密码失败，请稍后重试");
            }
          });
        }
      });
    },
    // 从忘记密码返回到登录
    fromForgetToLogin() {
      this.loginShow = true;
      this.forgetShow = false;
    },
    //点击忘记密码
    forgetPassword() {
      this.loginShow = false;
      this.forgetShow = true;
    },
    showProtocal(content, title) {
      this.dialog.visible = true;
      this.dialog.content = content;
      this.dialog.title = title;
    },
    enterKeyup() {
      document.addEventListener("keyup", this.enterKey);
    },
    enterKeyupDestroyed() {
      document.removeEventListener("keyup", this.enterKey);
    },
    enterKey(event) {
      const code = event.keyCode
        ? event.keyCode
        : event.which
        ? event.which
        : event.charCode;
      if (code == 13) {
        if (this.loginShow) {
          this.submitForm("loginForm");
        } else {
          this.regist("registForm");
        }
      }
    },
    //获取验证码
    getapiUserPhoneSms(state, flag, entrance) {
      let that = this;
      //如果手机号校验没通过点击也不让获取验证码
      if (this.disableCanVerfy) {
        return;
      }
      //根据入口判断校验哪个表单
      this.$refs[
        entrance === "registEntrance" ? "registForm" : "forgetForm"
      ].validateField("webPhone", errorMessage => {
        if (errorMessage) {
          return;
        }
        this.showVerifyBtn = false;
        this.hasGotCode = true;
        this.timer = setInterval(() => {
          if (this.time == 0) {
            window.clearInterval(this.timer);
            this.showVerifyBtn = true;
            this.time = 60;
          }
          this.time--;
        }, 1000);
        this.disableVerifyCode = false;
        this.disableVerifyCode2 = false;
        apiUserPhoneSms(
          {
            webProductId: this.apolloConfig.WORK.oemId,
            oemId: this.apolloConfig.WORK.oemId,
            webPhone:
              entrance === "registEntrance"
                ? this.registForm.webPhone
                : this.forgetForm.webPhone,
            webModelType: flag,
            webCheckType: "0",
            webTypeId:
              entrance === "registEntrance"
                ? this.registForm.typeId
                : this.forgetForm.typeId
          },
          "apiUserPhoneSms"
        ).then(res => {
          if (entrance === "registEntrance") {
            that.registForm.webValidSessionId = res.data.validSessionId;
          } else {
            that.forgetForm.webValidSessionId = res.data.validSessionId;
          }
        });
      });
    },
    //登录
    submitForm(loginForm) {
      this.$refs[loginForm].validate(valid => {
        if (valid) {
          this.$refs["loginForm"].validateField(
            "webValidateCode",
            errorMessage => {
              if (errorMessage) {
                return;
              }
              this.login(this.loginForm, this.apolloConfig);
            }
          );
        }
      });
    },

    login(loginForm, config) {
      let that = this;
      login({
        userName: loginForm.webPhone,
        webPhone: loginForm.webPhone,
        password: this.$md5(loginForm.password),
        webUserType: loginForm.typeId,
        productId: config.WORK.oemId,
        appId: config.WORK.appId
      })
        .then(res => {
          if (res.respCode === 100) {
            Global.messageSuc("登录成功");
            this.$root.verificationLogin(true);
            //设置cookie
            this.setCookieAfterLogin(this.apolloConfig, res.data);
            //设置请求的baseURL
            this.setPath(this.apolloConfig, res.data);
            //设置token
            this.setToken(this.apolloConfig, res.data);
            //设置webSocket参数
            let opts = {
              query: `oemId=${config.WORK.oemId}&appId=${config.WORK.appId}&token=${res.data.loginInfo.token}&userId=${res.data.userInfo.userId}`
            };
            this.webSocket = SocketIo.connect(this.globalWebsocketURL, opts);
            this.webSocket.on("connect", function() {
            });
            this.webSocket.on("push_event", function(data) {
              that.pushMessageMutation();
            });
            //设置头像
            this.userAvatarMutations(res.data.userInfo.avatar);
            let path = localStorage.getItem("intentPath") || "/";
            this.$router.push({ path });
            localStorage.removeItem("intentPath");
          } else if (res.respCode == -109) {
            try {
              this.$refs["loginForm"].fields[1].error =
                "账号或密码错误，请重新输入";
            } catch (e) {}
          } else {
            Global.callBack(res, this.loginError);
          }
        })
        .finally(() => {
          this.btntext = "登录";
          this.loading = false;
        });
    },

    //注册
    regist(registForm) {
      this.$refs[registForm].validate(valid => {
        if (!this.hasGotCode) {
          Global.messageErr("请点击获取验证码后，重新输入!");
          return;
        }
        if (valid) {
          this.btntext = "注册中";
          this.loading = true;
          userRegist(
            {
              webPhone: this.registForm.webPhone,
              webPassword: this.$md5(this.registForm.password2),
              webValidSessionId: this.registForm.webValidSessionId,
              webValidateCode: this.registForm.webValidateCode,
              WebTypeId: this.registForm.typeId,
              productId: this.apolloConfig.WORK.oemId,
              appId: this.apolloConfig.WORK.appId
            },
            "userRegist"
          )
            .then(res => {
              if (res.respCode === 100) {
                let loginForm = {
                  userName: res.data.phone,
                  webPhone: res.data.phone,
                  password: this.registForm.password2,
                  typeId: this.registForm.typeId
                };
                let userId = res.data.userId;
                //注册成功推送一条注册成功的消息
                this.pushMessageAddAction({
                  userId: userId,
                  noticeType: this.ClearMeaningConst.noticeType_userRegister,
                  dataId: userId,
                  dataType: 99 //99表示用户
                });
                this.login(loginForm, this.apolloConfig);
                // 注册成功后跳转至首页
                this.$router.push({ name: "home" }).catch(e => {});
              } else {
                Global.callBack(res, this.registError);
              }
            })
            .finally(() => {
              this.btntext = "登录";
              this.loading = false;
            });
        }
      });
    },
    setCookieAfterLogin(config, data) {
      this.$cookie.set("userInfo_productId", config.WORK.oemId, 7);
      this.$cookie.set("userInfo_appId", this.apolloConfig.WORK.appId, 7);
      this.$cookie.set("userInfo_userId", data.userInfo.userId, 7);
      this.$cookie.set("userInfo_refreshToken", data.loginInfo.refreshToken, 7);
      this.$cookie.set("userInfo_token", data.loginInfo.token, 7);
    },

    setPath(config, data) {
      RequestPath.webServiceInterface(
        config.WORK.oemId,
        config.WORK.appId,
        data.userInfo.userId,
        data.loginInfo.token
      );
      RequestPath.userInformatin(
        config.WORK.oemId,
        config.WORK.appId,
        data.userInfo.userId,
        data.loginInfo.token
      );
    },
    setToken(config, data) {
      api.setToken({
        oemId: config.WORK.oemId,
        appId: config.WORK.appId,
        userId: data.userInfo.userId,
        token: data.loginInfo.token,
        refreshToken: data.loginInfo.refreshToken
      });
    },
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCount = 0;
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    ...mapMutations("PersonalStore", [
      "userAvatarMutations",
      "pushMessageMutation"
    ])
  },
  beforeDestroy() {
    this.webSocket.close();
    this.$root.showBottomArea = true;
    // 销毁enter事件
    this.enterKeyupDestroyed();
  }
};
</script>
<style lang="less">
@import "~@/lesses/main/login.less";
</style>
